<template>
  <div class="public-header w-nav">
    <div class="public-header-container">
      <router-link :to="{ name: 'projects' }" class="pointer">
        <FixtenderIcon />
      </router-link>
      <div class="public-header__tender-name">
        {{ publicTenderInfo.name }}
      </div>
      <div class="public-header__deadline">
        {{ $t('Deadline') }}: {{ prettyDates(publicTenderInfo.offers_deadline_date) }}
      </div>
      <div class="public-header__right-side">
        <v-menu absolute offset-y>
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" class="public-header__lang-switcher" v-on="on">
              <span>{{ languagesMap[$i18n.locale] }}</span>
              <Icon type="chevron-down" size="16" color="oncolor" />
            </div>
          </template>
          <div class="dropdown-body dropdown-body_fit">
            <DropdownMenuElement v-if="$i18n.locale !== 'en'" @click.native="changeLocale('en')">
              {{ $t('English') }}
            </DropdownMenuElement>
            <DropdownMenuElement v-if="$i18n.locale !== 'lv'" @click.native="changeLocale('lv')">
              {{ $t('Latviešu') }}
            </DropdownMenuElement>
          </div>
        </v-menu>
        <Button size="small" type="secondary" @click.native="signUp">
          {{ $t('Sign in') }}
        </Button>
      </div>
    </div>
  </div>
</template>

<script>
  import FixtenderIcon from '@/assets/fixtender-white-text.svg';
  import { mapState } from 'vuex';
  import prettyDates from '@/utils/formatting/pretty-date';
  import Button from '@/components/ui-v2/Button';
  import { VMenu } from 'vuetify/lib';
  import DropdownMenuElement from '@/components/ui/dropdown-menu/DropdownMenuElement';
  import Icon from '@/components/ui/Icon';
  import { changeLocale } from '@/i18n';

  export default {
    name: 'HeaderOfPublicTender',
    components: {
      FixtenderIcon,
      VMenu,
      DropdownMenuElement,
      Icon,
      Button,
    },
    data() {
      return {
        languagesMap: {
          en: 'English',
          lv: 'Latviešu',
          ru: 'Русский',
        },
      };
    },
    computed: {
      ...mapState('publicTender', ['publicTenderInfo']),
    },
    methods: {
      changeLocale,
      prettyDates,
      async signUp() {
        await this.$router.push({
          name: 'login',
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  @import 'src/styles/pages/public-tender';
</style>
